// Per-anchor role-list constants for Turbo Service.
// Mirrors server/service-handlers/serviceAuthRules.ts.

import { MFG_DESK_ROLES, MFG_PURCHASING_ROLE } from "./turboManufacturingRoles";

/** Field seat for Service → Materials Usage. Does not open the manufacturing desk. */
export const MFG_REPAIR_TECHNICIAN_ROLE = "manufacturing_repair_technician";

/** Scheduling board + dispatcher surfaces (Board, Calendar, Rigs, etc.). */
export const SERVICE_DISPATCHER_ROLES: string[] = [
  "service_dispatcher",
  "service_admin",
  "owner",
  "admin",
  "org_admin",
  "org_owner",
  "platform_owner",
  "platform_admin",
  "platform_dev",
];

/** Inbound request approval queue. */
export const SERVICE_ADMIN_ROLES: string[] = [
  "service_admin",
  "owner",
  "admin",
  "org_admin",
  "org_owner",
  "platform_owner",
  "platform_admin",
  "platform_dev",
];

/** In-truck mobile surface — intentionally includes dispatcher/admin escape hatches. */
export const SERVICE_TECH_ROLES: string[] = [
  "service_tech",
  "service_dispatcher",
  "service_admin",
  "owner",
  "admin",
  "org_admin",
  "org_owner",
  "platform_owner",
  "platform_admin",
  "platform_dev",
];

/**
 * Service → Materials Usage. Repair techs capture. Purchasing and the
 * manufacturing desk read. Service admin edits recipients on Service setup.
 */
/** Draft capture. Purchasing and the desk read the mode but do not write drafts. */
export const SERVICE_MATERIALS_USAGE_WRITE_ROLES: string[] = [
  MFG_REPAIR_TECHNICIAN_ROLE,
  ...SERVICE_ADMIN_ROLES,
];

/** Rematch a submitted line. Quantity changes go on a correction report. */
export const SERVICE_MATERIALS_USAGE_REMATCH_ROLES: string[] = Array.from(
  new Set([MFG_PURCHASING_ROLE, ...MFG_DESK_ROLES, ...SERVICE_ADMIN_ROLES]),
);

export const SERVICE_MATERIALS_USAGE_ROLES: string[] = Array.from(
  new Set([
    MFG_REPAIR_TECHNICIAN_ROLE,
    MFG_PURCHASING_ROLE,
    ...MFG_DESK_ROLES,
    ...SERVICE_ADMIN_ROLES,
  ]),
);
